import { render, staticRenderFns } from "./AwaitingPayment.vue?vue&type=template&id=05130f00"
import script from "./AwaitingPayment.vue?vue&type=script&lang=js"
export * from "./AwaitingPayment.vue?vue&type=script&lang=js"
import style0 from "./AwaitingPayment.vue?vue&type=style&index=0&id=05130f00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports